import { render } from "./FormFloatingLabels.vue?vue&type=template&id=052244a8"
import script from "./FormFloatingLabels.vue?vue&type=script&lang=js"
export * from "./FormFloatingLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__